<template>
  <div class="resource-credentials-form-row">
    <div class="credentials-inputs-titles">
      <label> {{ $t('newProject.resources.login') }} </label>
      <label> {{ $t('newProject.resources.password') }} </label>
    </div>
    <div class="credentials-inputs">
      <v-text-field
        type="text"
        v-model="credential.username"
        class="login"
        :placeholder="$t('newProject.credential.enter.username')"
      />

      <v-text-field
        :append-icon="passwordAppendedIcon"
        :type="passwordVisibilityType"
        v-model="credential.password"
        @click:append="toggleShowPassword"
        :placeholder="$t('newProject.credential.enter.password')"
      />

      <span
        v-if="deletable"
        class="delete-icon material-icons"
        :title="$t('newProject.resources.delete')"
        @click="handleDelete(index)"
      >
        highlight_off
      </span>
      <div v-else class="dummy-icon" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResourceCredentialsFormRow',
  props: {
    credential: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    deletable: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    showPassword: false,
  }),
  computed: {
    passwordVisibilityType() {
      return this.showPassword ? 'text' : 'password';
    },
    passwordAppendedIcon() {
      return this.showPassword ? 'visibility_off' : 'visibility';
    },
  },
  methods: {
    toggleShowPassword() {
      this.showPassword = !this.showPassword;
    },
    handleDelete(credentialId) {
      this.$emit('delete', credentialId);
    },
  },
};
</script>

<style lang="scss">
.credentials-inputs {
  .v-text-field > .v-input__control > .v-input__slot:before,
  .v-text-field > .v-input__control > .v-input__slot:after {
    content: none;
  }
}
</style>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.resource-credentials-form-row {
  .credentials-inputs-titles {
    padding-top: $space-3;
    display: flex;
    text-transform: uppercase;
    color: var(--text-tertiary);
    font-size: $font-size-xs;
    letter-spacing: 0.8px;
    line-height: $font-size-xs;
    width: 100%;

    label {
      flex: 1;
    }
  }

  .credentials-inputs {
    display: flex;
    align-items: center;

    .v-text-field {
      flex: 1;
      height: $space-8;
      margin-top: $space-1 !important;
      margin-right: $space-3;
      padding: 0px;
      padding-left: $space-3;
      font-size: $font-size-base;
      line-height: $font-size-md;
      letter-spacing: 0;
      box-sizing: border-box;
      border: 1px solid var(--border-primary);
      border-radius: $radius-sm;
      color: var(--text-primary);
      background-color: var(--bg-primary);
    }

    .delete-icon {
      color: var(--severity-critical);
      cursor: pointer;
      font-size: $font-size-md;
      margin-top: $space-1;
    }

    .dummy-icon {
      width: $font-size-md;
      height: $font-size-md;
    }
  }
}
</style>
